import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { EProjectType } from '../../../enum/project';
import { IProjectItemProps } from './IProjectItem';
import './ProjectItem.scss';

const ProjectItem = (props: IProjectItemProps) => {
    const { t, i18n } = useTranslation();
    let options: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', day: 'numeric', month: 'long', hour: 'numeric', minute: 'numeric' };
    let date = new Date(props.project.lastUpdateDate).toLocaleDateString(i18n.language, options);
    return (
        <>
            <div className='d-flex justify-content-between p-1 cursor-pointer'>
                <div className='w-100 d-flex' onClick={props.onClick}>
                    <div className='w-30 me-5 ellipsis-simple-line name' title={props.project.projectName}>
                        {props.project.projectName}
                    </div>
                    <div className='w-30 me-5'>{date}</div>
                    <div className='w-30'>{props.project.projectType}</div>
                </div>
                <i className='fa-solid fa-trash' onClick={props.onDelete} />
            </div>
            <hr />
        </>
    );
};

export default ProjectItem;
